import { render } from "./MarketingDatatableTDMailingDate.vue?vue&type=template&id=0a1523e8"
import script from "./MarketingDatatableTDMailingDate.vue?vue&type=script&lang=js"
export * from "./MarketingDatatableTDMailingDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__